import "./Home.css";
import React from "react";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Stack,
  Text,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import { DownloadIcon } from "@chakra-ui/icons";
// import Fade from 'react-reveal/Fade';


export default function Home() {
  const handleClick = () => {
    console.log("hi");
    return window.open(
      "https://drive.google.com/file/d/1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF/view?usp=sharing",
      "_blank"
    );
  };
  return (
    <>
      <Box
        className="home section hero"
        id="home"
        w={["full", "full", "full", "full", "full"]}
      >
        <Box
          className="hero__container"
          h={["360px", "550px", "500px", "580px", "580px"]}
        >
        {/* <Fade left cascade> */}
          <Flex
            m={"auto"}
            justifyContent="space-between"
          >
            <VStack
              justify={"center"}
              px={useBreakpointValue({ base: 4, md: 8 })}
            >
              <Stack align={"center"} spacing={6}>
                <Text
                  id="user-detail-name"
                  color={"#00b9e8"}
                  fontWeight={500}
                  lineHeight={1.2}
                  fontSize={useBreakpointValue({ base: "3xl", md: "7xl" })}
                >
                  Hi, I'm Ayushi Vashisth
                </Text>

                <Box
                  color={"orange"}
                  fontSize={["13px", "24px", "24px", "42px", "42px"]}
                  textAlign={["left", "left", "left"]}
                  fontWeight={"700"}
                >
                  <Typewriter
                    options={{
                      strings: [
                        "I'm a Full Stack Web Developer.",
                        "I Love To Programming.",
                      ],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 50,
                    }}
                  />
                </Box>
                <Stack direction={"row"} border={"0px solid white"} width={["30%", "23%", "11%", "21%", "14%"]} m={"auto"}>
                  <IconButton
                    as="a"
                    href="https://github.com/AyushiVashisth"
                    bg={"#040724"}
                    border={"1px solid orange"}
                    color={"orange"}
                    // mt={["0px", "", ""]}
                    target="_blank"
                    _hover={{ bg: "orange", color: "blue" }}
                    icon={
                      <AiFillGithub
                        fontSize={["30px","30px","30px", "40px", "40px"]}
                      />
                    }
                  />
                  <IconButton
                    as="a"
                    href="https://www.linkedin.com/in/ayushi-vashisth-64722816b/"
                    bg={"#040724"}
                    border={"1px solid orange"}
                    color={"orange"}
                    target="_blank"
                    _hover={{ bg: "orange", color: "blue" }}
                    icon={<FaLinkedinIn fontSize={["30px","30px","30px", "40px", "40px"]} />}
                  />
                  
                </Stack>
                <Box>
                    <a
                      id="resume-link-2"
                      rel="noreferrer"
                      href="https://drive.google.com/uc?id=1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF&export=download"
                    >
                      <Button
                        id="resume-button-2"
                        // marginRight={"40px"}
                        position={"relative"}
                        display={"block"}
                        fontWeight={"900"}
                        textDecoration={"none"}
                        border-radius={"7px 5px"}
                        transition={"all 0.25s linear"}
                        z-index={1}
                        _hover={{ bgColor: "orange", color: "blue" }}
                        onClick={handleClick}
                        bg={"#040724"}
                        border={"1px solid orange"}
                        color={"orange"}
                        leftIcon={<DownloadIcon />}
                      >
                        Resume
                      </Button>
                    </a>
                  </Box>
              </Stack>
            </VStack>
          </Flex>
          {/* </Fade> */}
        </Box>
      </Box>
    </>
  );
}
